export const menuItems = [
  {
    label: 'Διαχείριση Χρηστών',
    icon: 'pi pi-user',
    routerLink: '/user/search',
    roles: ['Admin'],
  },
  {
    label: 'Διαχείριση Κλινικών',
    icon: 'pi pi-warehouse',
    routerLink: '/clinic/search',
    roles: ['Admin'],
  },
  {
    label: 'Ενιαία Λίστα Χειρουργείων',
    icon: 'fa fa-heartbeat',
    routerLink: '/surgeries-idika/list',
    roles: ['EkapyAdmin'],
  },
  {
    label: 'Ανατεθειμένα Χειρουργεία',
    icon: 'fa fa-hospital-o',
    routerLink: '/surgeries-assigned/list',
    roles: ['HospitalAdmin', 'ClinicAdmin'],
  },
  {
    label: 'Λίστα Χειρουργείων',
    icon: 'fa fa-hospital-o',
    routerLink: '/surgeries-assigned/list',
    roles: ['ViewOnly'],
  },
  {
    label: 'Παραλαβή Χειρουργείου',
    icon: 'fa fa-medkit',
    routerLink: '/surgery/receive',
    roles: ['PrivateHospitalAdmin', 'PrivateClinicAdmin'],
  },
  {
    label: 'Λίστα Ιδιωτικής Δομής',
    icon: 'fa fa-hospital-o',
    routerLink: '/surgeries-assigned/list',
    roles: ['PrivateHospitalAdmin', 'PrivateClinicAdmin'],
  },
  {
    label: 'Λίστα προς ιδιωτική δομή',
    icon: 'fa fa-h-square',
    routerLink: '/surgeries-private/list',
    roles: ['HospitalAdmin', 'ClinicAdmin'],
  },
  {
    label: 'Λίστα Χειρουργείων',
    icon: 'fa fa-hospital-o',
    routerLink: '/surgeries-citizen/list',
    roles: ['Citizen'],
  },
];
